import {
  StyledSkeletonContent,
  StyledSkeletonGradient,
  StyledSkeletonLoader,
} from './PropertyCardSkeleton.styles'

export const PropertyCardSkeleton = () => {
  return (
    <StyledSkeletonLoader aria-busy="true" aria-label="Loading property">
      <StyledSkeletonGradient />
      <StyledSkeletonContent>
        <StyledSkeletonGradient />
        <StyledSkeletonGradient />
        <StyledSkeletonGradient />
      </StyledSkeletonContent>
    </StyledSkeletonLoader>
  )
}
